import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ActionButton, ActionButtonVariants } from 'components/action-button';

import { LocationIcon } from './location-icon';

export const UseLocationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0 0.5rem;
  margin-block-start: 2rem;
`;

export const StyledActionButton = styled(ActionButton)`
  cursor: pointer;
`;

export const UseLocationDescription = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 70vw;
  line-height: 1rem;
`;

export const UseLocationText = styled.div`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9rem;
  font-weight: normal;
  text-align: start;

  ${Styles.desktop} {
    width: 100%;
  }
`;

interface IUseLocationActionButtonProps extends React.PropsWithChildren {
  onClick: VoidFunction;
}

export const UseCurrentLocationButton: React.FC<IUseLocationActionButtonProps> = ({
  onClick,
  children,
}) => {
  const { formatMessage } = useIntl();

  return (
    <UseLocationContainer>
      <LocationIcon />
      <StyledActionButton
        data-testid="use-current-location"
        onClick={onClick}
        as="div"
        variant={ActionButtonVariants.TEXT_ONLY}
      >
        <UseLocationDescription>
          <UseLocationText>{formatMessage({ id: 'deliveryUseCurrentLocation' })}</UseLocationText>
        </UseLocationDescription>
      </StyledActionButton>
      {children && children}
    </UseLocationContainer>
  );
};
